/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { Theme, TypographyProps } from '@coursera/cds-core';

const styles = {
  textWrapper: () => css`
    flex: 70%;
    padding-right: var(--cds-spacing-600);
  `,
  bannerWrapper: () => css`
    background-color: var(--cds-color-grey-25);
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
    border-radius: 4px;
  `,
};

type PropsFromCaller = {
  heading?: string | React.ReactNode;
  body: string | React.ReactNode;
  ctaContent?: React.ReactNode;
  customCss?: Interpolation<Theme>;
  typographyColor?: TypographyProps['color'];
};

type PropsToComponent = PropsFromCaller;

export const ProfileBanner = ({ heading, body, ctaContent, customCss, typographyColor }: PropsToComponent) => {
  return (
    <Grid container alignItems="center" justifyContent="space-between" css={[styles.bannerWrapper, customCss]}>
      <Grid item container direction="column" css={styles.textWrapper}>
        {heading && (
          <Typography2 component="h4" variant="subtitleMedium" color={typographyColor || 'supportText'}>
            {heading}
          </Typography2>
        )}
        <Typography2 component="p" color={typographyColor || 'supportText'}>
          {body}
        </Typography2>
      </Grid>
      {ctaContent}
    </Grid>
  );
};

export default ProfileBanner;
